import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import BrowserOnly from 'components/consumer/BrowserOnly';
import PDPDimensionsModal from 'components/consumer/PDP/PDPDimensionsModal';
import PDPDimensionsContent from 'components/consumer/PDP/PDPDimensionsContent';
import Placeholder from 'components/consumer/Placeholder';

const PDPDimensionsAndDetailsUI = ({ loading }) => {
  const [isDimensionsModalOpen, setIsDimensionsModalOpen] = useState(false);

  return (
    <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0]">
      <div className="items-center flex justify-between">
        <h2 className="text-xl font-bold text-gray">
          {loading ? (
            <Placeholder
              type="rect"
              loading
              style={{ height: '28px', width: '220px' }}
            />
          ) : (
            'Dimensions'
          )}
        </h2>

        {!loading && (
          <Link
            className="text-xs font-bold text-brand no-underline hover:cursor-pointer hover:underline"
            to="/fit-guide"
            target="_blank"
          >
            Measure for delivery
          </Link>
        )}
      </div>

      <PDPDimensionsContent
        onImageClick={() => {
          setIsDimensionsModalOpen(true);
        }}
        isSidebarContent
        pageLoading={loading}
      />

      <BrowserOnly>
        <PDPDimensionsModal
          isOpen={isDimensionsModalOpen}
          onClose={() => {
            setIsDimensionsModalOpen(false);
          }}
        />
      </BrowserOnly>
    </div>
  );
};

PDPDimensionsAndDetailsUI.propTypes = {
  loading: PropTypes.bool,
};

export default PDPDimensionsAndDetailsUI;
